module.exports = __webpack_public_path__ + "static/4_2_recommendation_NL-2b97e046ae13ec70a76b043844e24053.svg";